import {Injectable} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {BreadcrumbService} from 'xng-breadcrumb';
import {filter} from 'rxjs/operators';
import {applyAddListingTaxonomyBreadcrumbs, canonicalAddListingRouterUrl} from '../shared/listing-route.utils';

/** Rewrites malformed add-listing URLs and keeps taxonomy breadcrumbs in sync. */
@Injectable({providedIn: 'root'})
export class AddListingUrlCanonicalizerService {
  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) {}

  init(): void {
    this.router.events.pipe(
      filter((event): event is NavigationStart => event instanceof NavigationStart),
    ).subscribe(event => {
      const canonical = canonicalAddListingRouterUrl(event.url);
      if (canonical && canonical !== event.url) {
        void this.router.navigateByUrl(canonical, {replaceUrl: true});
      }
    });

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    ).subscribe(() => this.syncBreadcrumbs());
  }

  private syncBreadcrumbs(): void {
    if (!this.router.url.includes('/add-listing')) {
      return;
    }
    // Run after xng-breadcrumb handles GuardsCheckEnd for the same navigation.
    setTimeout(() => applyAddListingTaxonomyBreadcrumbs(this.breadcrumbService, this.router.url), 0);
  }
}
